export default "__VITE_ASSET__BLOztSLr__"